import { render, staticRenderFns } from "./MaterialSelector.vue?vue&type=template&id=2cd21388&"
import script from "./MaterialSelector.vue?vue&type=script&lang=js&"
export * from "./MaterialSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports